
const NavTag = {
  state: {
    navTagActive: '',
    navTagArr: []
  },

  mutations: {
    SET_NAVTAGACTIVE: (state, val) => {
      state.navTagActive = val
    },
    SET_NAVTAGARR: (state, val) => {
      state.navTagArr = JSON.parse(JSON.stringify(val))
    }
  },

  actions: {
    
  }
}

export default NavTag
